import { apiProvider } from './api';
import { router } from './router';

export const VozidloCDB = {
	apiProvider,
	router,
};
